import React, { useEffect, useState } from 'react'
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '../ui/resizable'
import { Loader2, Send, X } from 'lucide-react';
import { Input } from '../ui/input';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import axios from 'src/axios/axios';
import useAuth from 'src/hooks/useAuth';
import { format } from 'date-fns';
import { Button } from '../ui/button';
import { useWindowSize } from '@uidotdev/usehooks'
import toast, { Toaster } from 'react-hot-toast';
import FilePreview from '../files/file-previewer';
import { RootState } from 'src/store';
import { useAppSelector } from 'src/hooks/redux';

type P = {
    openDocument?: (document:DocumentObject) => void
}

const OpenCommunication = ({openDocument}:P) => {
    const colleagues:ForwardUser[] = useAppSelector((state:RootState) => state.colleagues);

    const { auth } = useAuth()
    const { t } = useTranslation()
    const { width } = useWindowSize()

    const [selected_communication, setselected_communication] = useState<undefined | number>(0);
    const [message, setmessage] = useState('');

    const { data:communication, refetch:refetchCommunication } = useQuery<Communcation[] | null>({
        queryKey: [`communication_${auth.data?.user.fitdocusername}`],
        queryFn: async () => {
            try {
                const { data } = await axios.get(`communications/get?username=${auth.data?.user.fitdocusername}&state=1`)
                if(data.errorcode!==0){ throw new Error(data.message) }
                return sortCommunication(data.object)
            } catch (error) {
                console.log(error);
                return null
            }
        }
    })

    const { mutate:sendMessage, reset, isLoading } = useMutation({
        mutationFn: async () => {
            try {
                if(!communication || selected_communication === undefined) return;
                const { data } = await axios.post(`communications/message/add`, {
                    token: auth.data?.token,
                    documentquestionheaderid: communication[selected_communication].documentsquestionheaderid,
                    message: message
                })
                if(data.errorcode!==0){ throw new Error(data.message) }
                reset();
                setmessage('')
                refetchCommunication()
            } catch (error) {
                console.log(error)
            }
        }
    })

    async  function handleOpenDocument(docid:string | number) {
        try {
            console.log("openen")
            toast.loading(`${t('Document openen')}...`, { id:'openDocument' })
            const { data } = await axios.get(`documents/get?docid=${docid}`)
            if(data.errorcode!==0){ throw new Error(data.message) }
            toast.remove('openDocument')
            
            openDocument && openDocument({docid:data.object.docid, docdate:'', doctype:data.object.doctype, filename:data.object.filename, metadata:[], version:1, remarks:[], options:{wf:0, favorite:0}, user:''})

        } catch (error) {
            console.log(error);
            toast.error(`${t('Document openen mislukt')}`, { id:'openDocument' })
        }
    }

    function sortCommunication (communication:Communcation[]) {
        if(!communication) return []
        
        let tmp = [...communication]

        tmp.sort(function(a, b) {
            var dateA = new Date(a.lastmodif);
            var dateB = new Date(b.lastmodif);
          
            if (dateA > dateB ) {
              return -1;
            }
            if (dateA < dateB ) {
              return 1;
            }
            return 0;
        });

        return tmp
    }

    function usernameToName(name:string) {
        let n = name
        const user = Array.isArray(colleagues) ? colleagues.find(u=>u.username.toLowerCase() === name.toLowerCase()) : undefined
        if(user){
            n = `${user.firstname} ${user.name}`
        }
        return n
    }

    const screenWidth = width ? width : 0

    if((!communication) || (communication && communication.length === 0)){ return <></> }

  return (
    <div className='max-w-3xl'>
        <h3 className="mb-2 font-semibold text-neutral-600">{t('Openstaande communicatie')} ({communication ? communication.length : 0})</h3>
        <div className='h-full min-h-[600px] md:min-h-[400px] md:max-h-[400px] overflow-hidden border rounded-md'>
            <ResizablePanelGroup direction={screenWidth >= 767 ? 'horizontal' : 'vertical'} className='min-h-[inherit]'>
                <ResizablePanel defaultSize={screenWidth >= 1400 ? 20 : 40} className='bg-white md:max-h-[400px] !overflow-auto'>
                    <div className='flex flex-col gap-2 p-4'>
                        {communication && communication.map((com,i)=>(
                            <div onClick={()=>{if(i===selected_communication){setselected_communication(undefined)}else{setselected_communication(i)}}} className={`border rounded-sm p-2 flex flex-col gap-2 overflow-hidden cursor-pointer hover:bg-blue-100 ${selected_communication === i && 'bg-blue-100'}`} key={`communication-${i}`}>
                                <div className='flex items-center justify-between gap-4'>
                                    <div className='flex items-center gap-2'>
                                        <div className='flex items-center justify-center w-6 h-6 text-xs bg-white border rounded-full border-sky-200'>{com.Messages.Message.filter(m=>m.inforecord===false).length || 0}</div>
                                        <p className='font-medium'>{usernameToName(com.createdby)}</p>
                                    </div>
                                    <p className='text-xs text-right'>{t('Laatste bericht')} {usernameToName(com.Messages.Message[com.Messages.Message.length-1].username)} {format(new Date(com.lastmodif), "dd/MM/yyyy - HH:mm")}</p>
                                </div>
                                <div className='flex items-center gap-2'>
                                    <p className='bg-primary/20 text-primary font-medium px-2 py-0.5 rounded-sm text-sm'>
                                        {com.state.toString()==='1' && t('Open')}
                                        {com.state.toString()!=='1' && t('Gesloten')}
                                    </p>
                                    <p className='font-semibold'>{com.title}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </ResizablePanel>
                <ResizableHandle withHandle/>

                {(communication) && 
                <ResizablePanel defaultSize={screenWidth >= 1400 ? 40 : 60} className='bg-neutral-50 md:max-h-[400px] !overflow-auto'>
                    <div className='flex flex-col gap-4 p-4'>
                        <div className='flex gap-2 pb-4 overflow-auto border-b'>
                            <Button onClick={()=>{if(communication && (typeof(selected_communication) === 'number')){ handleOpenDocument(communication[selected_communication].docid) }}} variant='outline' size='sm'>Open document</Button>
                        </div>
                        <div className='flex items-center justify-between w-full gap-4'>
                            <div className='flex items-center gap-2 overflow-auto'>
                                {(communication && (typeof(selected_communication) === 'number')) ? communication[selected_communication].Users.User.map((user, index)=>(
                                    <p key={`user-${index}`} className='bg-primary text-primary-foreground text-xs px-2 py-0.5 rounded-sm flex items-center gap-1 whitespace-nowrap'>{usernameToName(user.username)}</p>
                                )) : ''}
                            </div>
                            <div>
                                <p className='text-xs text-right text-neutral-400'>Te sluiten door: {(communication && selected_communication) ? (usernameToName(communication[selected_communication].rightstoclose) || '') : ''}</p>
                            </div>
                        </div>
                        <p className='font-semibold'>{(communication && (typeof(selected_communication) === 'number')) ? communication[selected_communication].title : ''}</p>
                        <div className='flex flex-col gap-4'>
                            <div className="flex flex-col w-full gap-2">
                                {(communication && (typeof(selected_communication) === 'number')) ? communication[selected_communication].Messages.Message.map((message, index)=>{
                                    const isInfo = message.inforecord
                                    const infoClass = 'bg-yellow-200'
                                    const messageClass = 'bg-blue-200'
                                    return (
                                    <div className={`${isInfo ? 'items-start' : 'items-end'} flex flex-col w-full`} key={message.documentsquestionrecordid}>
                                        <p className="text-xs text-neutral-400">{message.username && `${usernameToName(message.username)}:`} {format(new Date(message.datecreated), "dd/MM/yyyy")} - {message.timecreated.substring(0,5)}</p>
                                        <div className={`${isInfo ? infoClass : messageClass} font-medium border px-2 py-1 w-fit rounded-[17px]`} key={message.documentsquestionrecordid}>
                                            <p>{message.messagerecord}</p>
                                        </div>
                                    </div>
                                    )
                                }) : ''}
                            </div>

                            <div className="flex items-center gap-2 mt-4">
                                <Input onKeyDown={(e)=>{if(e.key==='Enter'){sendMessage()}}} value={message} onChange={({currentTarget})=>{setmessage(currentTarget.value)}} placeholder={`${t('Typ een bericht')}...`} className={`w-full rounded-full`}/>
                                <button onClick={()=>{sendMessage()}} disabled={isLoading} className={`${message.length > 1 ? 'w-[40px] px-3 ' : 'w-[0px] px-0 pointer-events-none'} h-10 bg-primary text-primary-foreground rounded-full`}>
                                    {!isLoading ? <Send className="w-4 h-4"/> : <Loader2 className='w-4 h-4 animate-spin'/>}
                                </button>
                            </div>
                        </div>
                    </div>
                </ResizablePanel>
                }
            </ResizablePanelGroup>
        </div>
    </div>
  )
}

export default OpenCommunication